// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"SectionContent_sectionContent_1GD5B"};